import { SettingsIcon, TemplatesIcon } from 'icons';
import { WizardModal, WizardModalProps } from 'components/WizardModal';

import { StepSelectTemplate } from './StepSelectTemplate';
import { StepSettingsForm } from './StepSettingsForm';

export type NewFormWizardProps = Omit<WizardModalProps, 'steps' | 'title'>;

export const NewFormWizard: React.FC<NewFormWizardProps> = props => (
  <WizardModal
    {...props}
    steps={[
      {
        label: 'forms:newFormWizard.selectTemplate',
        content: StepSelectTemplate,
        icon: TemplatesIcon,
      },
      {
        label: 'forms:newFormWizard.configureForm',
        content: StepSettingsForm,
        icon: SettingsIcon,
      },
    ]}
    title="forms:newFormWizard.title"
  />
);
